// teamSlice.js
import { createSlice } from '@reduxjs/toolkit';

const teamSlice = createSlice({
  name: 'team',
  initialState: {
    activeGroup: false,
    activeGroupSideBar: false,
  },
  reducers: {
    setActiveGroup: (state, action) => {
      state.activeGroup = action.payload;
    },
    setActiveGroupSideBar: (state, action) => {
      state.activeGroupSideBar = action.payload;
    },
  },
});

export const { setActiveGroup, setActiveGroupSideBar } = teamSlice.actions;


export const selectActiveGroup = (state) => state.team.activeGroup;
export const selectActiveGroupSideBar = (state) => state.team.activeGroupSideBar;

export default teamSlice.reducer;
